import React from "react"
import { Flex } from "antd"
import { UserOutlined, MailOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import styles from "./index.module.css"
import { spacings } from "themes/variables"

const BookingCard = ({ booking }) => {
  const { t } = useTranslation()
  const hasClientDetails = booking?.client_name || booking?.client_email
  return (
    <Flex vertical gap={12}>
      <Flex align="center" gap={16} className={styles.bookingCard}>
        {booking?.image && <img src={booking.image} alt="trip" className={styles.bookingImage} />}
        <Flex vertical gap={4}>
          {booking?.title && <Text strong>{booking.title}</Text>}
          {booking?.booking_id && <Text type="secondary">{t("bookings.cancel_modal.booking_id", { id: booking.booking_id })}</Text>}
          {booking?.booked_on && <Text type="secondary">{t("bookings.cancel_modal.booked_on", { date: booking.booked_on })}</Text>}
        </Flex>
      </Flex>
      {hasClientDetails && (
        <Flex gap={spacings["3XL"]} className="pl-s">
          {booking.client_name && (
            <Flex align="center" gap={8}>
              <UserOutlined />
              <Text>{booking.client_name}</Text>
            </Flex>
          )}
          {booking.client_email && (
            <Flex align="center" gap={8}>
              <MailOutlined />
              <Text type="secondary">{booking.client_email}</Text>
            </Flex>
          )}
        </Flex>
      )}
    </Flex>
  )
}

BookingCard.propTypes = {
  booking: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    booking_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    booked_on: PropTypes.string,
    client_name: PropTypes.string,
    client_email: PropTypes.string
  })
}

export default BookingCard
